import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostFacebookLogin = () => {
  return useMutation({
    mutationFn: authService.postFacebookLogin,
    throwOnError: false,
  });
};
